// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"PatchworkGallery_imageWrapper__vkMSh","videoWrapper":"PatchworkGallery_videoWrapper__RLcKV","image":"PatchworkGallery_image__lSxJ5"};